import {html} from 'lit';
import {customElement, state} from 'lit/decorators.js';
import B2bElement from '../../../../b2b-element.js';
import B2bPublicServiceClientProxy
  from '../../../../gen/com/arabellesolutions/sdc/b2b/pub/B2bPublicServiceClientProxy.js';
import LoginCredentials from '../../../../gen/com/arabellesolutions/sdc/b2b/pub/utils/LoginCredentials.js';
import defaultStyle from '../../../b2b-public-styles.scss';
import ExternalUserNotVerified
  from '../../../../gen/com/arabellesolutions/sdc/b2b/common/user/ExternalUserNotVerified.js';
import {when} from 'lit/directives/when.js';
import ExternalUserNotActive from '../../../../gen/com/arabellesolutions/sdc/b2b/common/user/ExternalUserNotActive.js';

@customElement('b2b-public-login')
export class B2bPublicLogin extends B2bElement {
  static styles = [defaultStyle];

  /** @type {LoginCredentials} */
  @state()
  accessor __credentials = new LoginCredentials();

  @state()
  accessor __userNotVerified;

  @state()
  accessor __userNotActive;

  __b2bPublicServiceProxy = new B2bPublicServiceClientProxy(super.msgpackClientPublic());

  /**
   * @param {LoginCredentials} entry
   * @return {Promise<!boolean>}
   */
  __submit = entry => this.__b2bPublicServiceProxy.loginExternalUser(entry)
      .catch(e => {
        if (e instanceof ExternalUserNotVerified) {
          this.__userNotVerified = true;
        } else if (e instanceof ExternalUserNotActive) {
          this.__userNotActive = true;
        } else {
          throw e;
        }
      });

  render() {
    return html`
      <mta-page-title page-name="login" title="Login"></mta-page-title>
        <mta-message>
          ${when(!this.__userNotVerified && !this.__userNotActive, () => html`
            <div class="page-container">
              <mta-form
                  .value="${this.__credentials}"
                  @success="${this.__submitted}"
                  @keydown="${this.__onKeyDown}"
                  success-message="User logged in successfully">
                <div class="menu-top-left">
                  <common-mta-logo class="logo" url=""></common-mta-logo>
                </div>
                <div class="form-header">
                    <h2>Log in</h2>
                </div>
                <div class="input-group">
                  <mta-form-input name="email" label="Email" required></mta-form-input>
                  <mta-form-input
                      type="password"
                      name="password"
                      label="Password"
                      required></mta-form-input>
                </div>
                <a href="#/auth/forgotPassword" class="forgot-link">Forgot your password ?</a>
                <mta-form-buttons hide-cancel="true" submit-label="Log in" .submit="${this.__submit}"></mta-form-buttons>
                <div class="divider">
                  <span>or</span>
                </div>
                <p class="registration-link">Don't have an account? <a href="#/auth/registration">Create account</a></p>
              </mta-form>
            </div>
          `, () => html`
            ${when(this.__userNotActive, () => html`
              <div id="error">
                <h1>Your account is not active yet, please contact your Power User / MTA support team to active it</h1>
              </div>
            `, () => html`
              <div class="page-container">
                <div class="menu-top-left">
                    <common-mta-logo class="logo" url=""></common-mta-logo>
                </div>
                <div class="form-header">
                  <h2>Account Is Not Verified</h2>
                  <p>You have not verified your account, please click below to proceed:</p>
                </div>
                <a @click="${this.__resendEmail}" href="#/auth/email">Verify now</a>
              </div>
            `)}
          `)}
        </mta-message>
    `;
  }

  connectedCallback() {
    super.connectedCallback();
    this.resetState();
  }

  resetState() {
    this.__userNotActive = false;
    this.__userNotVerified = false;
  }
  __resendEmail() {
    this.__b2bPublicServiceProxy.resendVerificationEmail(this.__credentials.email);
  }

  __onKeyDown(e) {
    if (e.keyCode === 13) {
      const form = this.shadowRoot.querySelector("mta-form");
      const buttons = this.shadowRoot.querySelector("mta-form-buttons");

      form.resetStateHistory();
      buttons.submit(this.__credentials).then(() => this.__submitted());
    }
  }

  __submitted() {
    this.__b2bPublicServiceProxy.redirectToAppUrl()
      .then(url => {
        if (url !== null) {
          window.location.replace(url);
          if (!url.includes("oauth2")) { // /oauth2/authorize uri
            window.location.reload();
          }
        } else {
          this.redirect('#/home');
          window.location.reload();
        }
      });
    // temporarily disable mfa
    // this.redirect('#/auth/mfa');
  }
}
